import React, { useContext } from 'react';
import AppContext from '../context/context';


const Contact = () => {
	
		const context = useContext(AppContext)
			
		return(
			<>

				<div className="row">
				
					<div className="col-lg-10 scroll-margin">
												
						<h1 id="contato" className="mt-4 type-writer mb-4" style={{marginLeft: "-2px"}}>Contato</h1>
						<div className="row contato">
							<div className="col-lg-10 mb-3">
								<h5 aria-hidden="true">Vamos conversar?</h5>
								<h6 aria-hidden="true">Fale comigo através do formulário abaixo.</h6>
							</div>

							<div className="col-lg-10 mb-3">
							
									<form className="formulario-contato" action={context.state.formUrl} method="POST">

									  <div className="form-row">
										<div className="col">
										  <label htmlFor="nome" aria-hidden="true">Seu nome</label>
										  <input type="text" name="name" className="form-control shadow-none" id="nome" placeholder="" aria-label="Digite o seu nome." required/>
										</div>
										<div className="col">
										  <label htmlFor="email" aria-hidden="true">Seu e-mail</label>
										  <input type="email" name="_replyto" className="form-control shadow-none" id="email" placeholder="" aria-label="Digite o seu e-mail." required/>
										</div>
									  </div><br/>

									  <div className="form-group">
										<label htmlFor="mensagem">Sua mensagem</label>
										<textarea name="message" className="form-control shadow-none" id="mensagem" rows="5" required></textarea>
									  </div>
									  <button type="submit" className="btn text-white" style={{backgroundColor: "#0f1014"}} aria-label="enviar mensagem">Enviar mensagem</button>

									</form>
									<br/>
							</div>
						</div>
						
						
						
					</div>
					<div className="col-sm-2"></div>
					
				</div>
				
			</>
		)
}

export default Contact;